module.exports = __webpack_public_path__ + "img/pic3.8b96aaaa.png";